import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import EditableContainer from '@v4/components/common/EditableContainer'
import EditableHTML from '@v4/components/common/EditableHTML'
import { Box } from '@material-ui/core'
import VideoBlock from '@v4/components/sections/Video/components/VideoBlock'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useVideo7 } from './Video7.hooks'

const Video7 = props => {
	const [
		{
			classes,

			video,

			title,
			titleKey,
			titleConfig,
			titleEditable,

			text,
			textKey,
			textConfig,
			textEditable,
		},
		{ handleTitleClick, handleTitleChange, handleTextClick, handleTextChange },
	] = useVideo7(props)

	return (
		<>
			<EditableContainer
				visible={!!title}
				fieldConfig={titleConfig}
				onAdd={handleTitleChange}
				editable={titleEditable}
				wrapper={({ children }) => (
					<Box width="100%" mb={4.5}>
						{children}
					</Box>
				)}
			>
				<EditableHTML
					key={titleKey}
					className={clsx(classes.title, 'video7-title-block')}
					html={title}
					onClick={handleTitleClick}
					editable={titleEditable}
					onChange={handleTitleChange}
				/>
			</EditableContainer>

			{video?.metaValue && (
				<div key={video.tierKey} className={clsx(classes.container, 'video7-video-container')}>
					<VideoBlock className="video7-video-block" value={video.metaValue} />
				</div>
			)}

			<EditableContainer
				visible={!!text}
				fieldConfig={textConfig}
				onAdd={handleTextChange}
				editable={textEditable}
			>
				<EditableHTML
					key={textKey}
					className={clsx(classes.text, 'video7-description-block')}
					html={text}
					onClick={handleTextClick}
					editable={textEditable}
					onChange={handleTextChange}
				/>
			</EditableContainer>
		</>
	)
}

Video7.propTypes = {
	metaData: PropTypes.shape({
		title: PropTypes.instanceOf(PageMetaData),
		video: PropTypes.instanceOf(PageMetaData),
		text: PropTypes.instanceOf(PageMetaData),
		backgroundDefault: PropTypes.instanceOf(PageMetaData),
		marginTop: PropTypes.instanceOf(PageMetaData),
		marginBottom: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Video7)
